import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import "../css/about.scss";
import { FaInstagram, FaFacebookF, FaTiktok, FaYoutube } from "react-icons/fa";

function About() {
  return (
    <div className="about">
      <Header />

      <main className="about-main">
        {/* Hero Section */}
        <section className="about-hero">
          <div className="hero-text-box">
            <h1 className="hero-title">
              How Petmorvanto Brands
              <br />
              Came to Be
            </h1>
            <p className="hero-subtitle">
              What began as a quest to make the perfect bed for our wiggly pug,
              Momo, has grown into a family of brands known for quality,
              craftsmanship and playful design.
            </p>
          </div>
        </section>

        {/* Story Section */}
        <section className="about-story">
          <div className="story-header">
            <h2 className="story-heading">Our Story</h2>
            <div className="story-social-icons">
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noreferrer"
                className="social-icon"
              >
                <FaInstagram />
              </a>
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noreferrer"
                className="social-icon"
              >
                <FaFacebookF />
              </a>
              <a
                href="https://tiktok.com"
                target="_blank"
                rel="noreferrer"
                className="social-icon"
              >
                <FaTiktok />
              </a>
              <a
                href="https://youtube.com"
                target="_blank"
                rel="noreferrer"
                className="social-icon"
              >
                <FaYoutube />
              </a>
            </div>
          </div>

          <div className="story-content">
            <div className="story-left">
              <h3 className="story-main-title">
                Joyfully
                <br />
                Designed.
                <br />
                Ethically
                <br />
                Made.
              </h3>
            </div>

            <div className="story-right">
              <p>
                Petmorvanto Brands brings together nearly two decades of
                thoughtful design, craftsmanship and care into one unified
                vision for pets and their people.
              </p>

              <p>
                Our story began with a simple goal: create the perfect bed for
                our wiggly pug, Momo. What started as one product has grown into
                a beloved collection of toys, beds and lifestyle essentials
                designed to bring joy to everyday moments.
              </p>

              <p>
                Today, Petmorvanto Brands is home to a family of distinct
                brands, each created to support different parts of a pet's life.
              </p>

              <p>
                <span className="brand-highlight">Play</span> offers durable,
                design-forward dog toys and comfort-driven beds made for every
                play style and sleep style. From enrichment favorites to cozy
                loungers, these are the products that built our reputation.
              </p>

              <p>
                <span className="brand-highlight italic">Feline Frenzy</span> is
                dedicated to curious cats, creating toys and enrichment
                experiences that inspire instinct-driven play and keep felines
                engaged.
              </p>

              <p>
                <span className="brand-highlight">Scout and About</span>{" "}
                supports outdoor adventures with thoughtfully designed gear made
                for trails, travel days and everyday exploration.
              </p>

              <p>
                <span className="brand-highlight">LeftPine</span> offers
                lifestyle-driven designs created for modern pet homes, bringing
                elevated aesthetics and accessible comfort to high-volume retail
              </p>

              <p>
                Every product we create is joyfully designed and ethically made.
                Because we own and operate our family-owned factory, we maintain
                full oversight of materials, manufacturing practices and
                employee welfare. This allows us to uphold the highest standards
                of quality while ensuring safe working conditions and
                responsible production.
              </p>

              <p>
                Our toys and beds are crafted with certified non-toxic
                materials, reinforced stitching and durable fabrics built to
                last. Inside, our signature PlanetFill filling is made from 100
                percent post-consumer recycled plastic bottles, transforming
                waste into soft, supportive comfort.
              </p>

              <p>
                We are proud to be a Certified B Corporation, meeting rigorous
                standards for social and environmental performance, transparency
                and accountability. Sustainability is not a trend for us. It is
                built into how we design, manufacture and grow.
              </p>

              <p>
                At Petmorvanto Brands, we believe pets are family. Our mission
                is simple: create products that spark joy, support well-being
                and make everyday life a little more playful.
              </p>

              <div className="pug-image-container">
                <img
                  src="/main/main3.webp"
                  alt="Momo the Pug sitting on yellow chair"
                  className="pug-image"
                />
              </div>

              <p className="pug-caption">
                Momo, our beloved Chief Pug Officer, was more than our first
                model, she was the heart behind the brand. Her love of comfort,
                playful spirit and daily insistence on the very best inspired
                our first bed and everything that followed. Though she has
                crossed the rainbow bridge, her legacy lives on in every
                thoughtfully designed product we create.
              </p>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}

export default About;
